import { Badge, BadgeVariant } from "@/components/ui/badge";
import { useActiveOrgMembers } from "@/queries/organization-members";
import { UserIcon } from "lucide-react";

import {
  Container,
  Item,
  ItemAction,
  ItemContent,
  ItemIcon,
  ItemTitle,
} from "../../components/Container";
import {
  Section,
  SectionHeader,
  SectionItem,
  SectionTitle,
} from "../../components/Section";
import InviteMember from "./InviteMember";
import MemberActions from "./MemberActions";

const OrganizationMembers = () => {
  const usersQuery = useActiveOrgMembers();
  const members = usersQuery.data?.items || [];

  return (
    <Section>
      <SectionItem>
        <SectionHeader>
          <SectionTitle>Organization Members</SectionTitle>
          <InviteMember />
        </SectionHeader>
      </SectionItem>
      <SectionItem>
        <Container>
          {members.map((member) => (
            <Item key={member.id}>
              <ItemContent>
                <ItemIcon>
                  <UserIcon />
                </ItemIcon>
                <ItemTitle>{member.user.email}</ItemTitle>
              </ItemContent>
              <ItemAction>
                <Badge
                  variant={
                    member.organization_role.name === "user"
                      ? BadgeVariant.SECONDARY
                      : BadgeVariant.DEFAULT
                  }
                  className="capitalize"
                >
                  {member.organization_role.name}
                </Badge>
                <MemberActions organizationMember={member} />
              </ItemAction>
            </Item>
          ))}
        </Container>
      </SectionItem>
    </Section>
  );
};

export default OrganizationMembers;
